import { useEffect, useState } from "react";
import QuestionHeader from "./QuestionHeader";
import QuestionEditor from "./QuestionEditor";

export default function QuestionBlock({
  question,
  collapseTrigger,
  onDelete,
  onUpdate,
  lastAddedId,
}) {
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    if (question.id !== lastAddedId) {
      setCollapsed(true);
    } else {
      setCollapsed(false);
    }
  }, [collapseTrigger, question.id, lastAddedId]);

  return (
    <div className="shadow-sm mb-6 bg-white dark:bg-gray-900">
      <QuestionHeader
        question={question}
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        onDelete={() => onDelete(question.id)}
      />
      {!collapsed && (
        <QuestionEditor
          question={question}
          onUpdate={onUpdate}
        />
      )}
    </div>
  );
}
